import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "@phosphor-icons/react";
import { useI18n } from "../lib/i18n";

const KEY = "tf_cookie_consent";

export default function CookieBanner() {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (!v) setOpen(true);
    } catch { /* ignore */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, JSON.stringify({ status: "accepted", at: new Date().toISOString() })); } catch { /* ignore */ }
    setOpen(false);
  };
  const dismiss = () => {
    try { localStorage.setItem(KEY, JSON.stringify({ status: "essential_only", at: new Date().toISOString() })); } catch { /* ignore */ }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-50 w-[min(95vw,420px)] tf-card p-5 shadow-2xl animate-in fade-in slide-in-from-bottom-3"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3">
        <Cookie size={28} weight="duotone" className="shrink-0 text-[var(--tf-ink)] mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="font-display font-black text-base">{t("cb_title")}</div>
          <p className="text-xs text-[var(--tf-muted)] mt-1.5 leading-relaxed">
            {t("cb_body")}{" "}
            <Link to="/legal/cookies" className="underline font-bold text-[var(--tf-ink)]">Cookie Policy</Link>.
          </p>
        </div>
        <button onClick={dismiss} className="text-[var(--tf-muted)] hover:text-[var(--tf-ink)] shrink-0" aria-label={t("cb_close_aria")} data-testid="cookie-dismiss">
          <X size={16} weight="bold" />
        </button>
      </div>
      <div className="flex gap-2 mt-4">
        <Link to="/legal/cookies" className="tf-btn tf-btn-ghost text-xs flex-1 justify-center" data-testid="cookie-learn">
          {t("cb_more_info")}
        </Link>
        <button onClick={accept} className="tf-btn tf-btn-primary text-xs flex-1 justify-center" data-testid="cookie-accept">
          {t("cb_accept")}
        </button>
      </div>
    </div>
  );
}
